import Vue from "vue";
import VueRouter from "vue-router";
import NProgress from "nprogress";
import { loginByTrail, ssoVerify } from "@/services/LoginService";
import store from "../store/store";
import blackRoutes from "./blackRoutes";
import { form } from "@/services/HttpService";

//解决点击相同菜单报NavigationDuplicated错误
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
  // 登录
  {
    path: "/login",
    name: "Login",
    component: () => import(/* webpackChunkName: "Login" */ "@/views/Login"),
  },
  // 首页
  {
    path: "/",
    name: "HomeIndex",
    meta: {
      hasBar: true,
      keepAlive: true,
    },
    component: () =>
      import(/* webpackChunkName: "HomeIndex" */ "@/views/homeIndex"),
  },
  // 资源详情
  {
    path: "/resource-detail/:productId",
    name: "ResourceDetail",
    meta: {
      hasBar: true,
      fatherName: ["HomeIndex"],
    },
    component: () =>
      import(/* webpackChunkName: "ResourceDetail" */ "@/views/ResourceDetail"),
  },
  // 支付
  {
    path: "/payment",
    name: "Payment",
    meta: {
      fatherName: ["HomeIndex"],
    },
    component: () =>
      import(/* webpackChunkName: "Payment" */ "@/views/Payment"),
  },
  {
    path: "/check-product-detail/:id/:type",
    name: "CheckProductDetail",
    component: () =>
      import(/* webpackChunkName: "Payment" */ "@/views/checkProductDetail"),
  },
  {
    path: "/adm",
    name: "Admin",
    component: () =>
      import(/* webpackChunkName: "Admin" */ "@/views/Admin.vue"),
    children: [
      {
        path: "personal-details",
        name: "PersonalDetails",
        meta: {
          hasPersonBar: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "ProjectManagement" */ "@/views/PersonalDetails"
          ),
      },
      // 资源管理-上传资源
      {
        path: "upload-resource",
        name: "UploadResource",
        meta: {
          hasPersonBar: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "UploadResource" */ "@/views/resource-mgn/UploadResource"
          ),
      },
      {
        path: "tag",
        name: "Tag",
        meta: {
          hasPersonBar: true,
        },
        component: () =>
          import(/* webpackChunkName: "Message" */ "@/views/Tag"),
      },
      {
        path: "modify-personal-details",
        name: "ModifyPersonalDetails",
        meta: {
          hasPersonBar: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "ModifyPersonalDetails" */ "@/views/modifyPersonalDetail"
          ),
      },
      {
        path: "shopping-car",
        name: "ShoppingCar",
        meta: {
          hasPersonBar: true,
        },
        component: () =>
          import(/* webpackChunkName: "ShoppingCar" */ "@/views/shoppingCar"),
      },
      {
        path: "message",
        name: "Message",
        meta: {
          hasPersonBar: true,
        },
        component: () =>
          import(/* webpackChunkName: "Message" */ "../views/message"),
      },

      // 收藏夹
      {
        path: "favorites",
        name: "Favorites",
        meta: {
          hasPersonBar: true,
        },
        component: () =>
          import(/* webpackChunkName: "Favorites" */ "@/views/Favorites"),
      },
      // 待审核
      {
        path: "stay-audit",
        name: "StayAudit",
        meta: {
          hasPersonBar: true,
        },
        component: () =>
          import(/* webpackChunkName: "StayAudit" */ "@/views/stayAudit"),
      },
      // 已通过
      {
        path: "already-passed",
        name: "AlreadyPassed",
        meta: {
          hasPersonBar: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "AlreadyPassed" */ "@/views/alreadyPassed"
          ),
      },
      // 已驳回
      {
        path: "already-reject",
        name: "AlreadyReject",
        meta: {
          hasPersonBar: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "AlreadyReject" */ "@/views/alreadyReject"
          ),
      },
    ],
  },
  ...blackRoutes,
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.query.code) {
    // 如果code存在，则设置token
    ssoVerify(to.query.code).then(res => {
      let data = res.data;
      if (data.code === 200) {
        localStorage.setItem("nickName", data.data.userName);
        localStorage.setItem("token", data.data.token)
        localStorage.setItem("userId", data.data.userId)
        localStorage.setItem("profilePictureUrl", data.data.profilePictureUrl);
        localStorage.setItem("roleIds", data.data.roleIds);
        store.state.isMyPage = true;
        NProgress.start();
        //去掉code
        let query = {
          ...to.query,
        }
        delete query.code;
        next({
          ...to,
          query: query
        });
      } else {
        store.dispatch("openVuex", "");
        store.dispatch("checkId", "817485bf52754d8880cb97789f88141d");
        localStorage.removeItem("token");
        localStorage.removeItem("userId");
        localStorage.removeItem("nickName");
        localStorage.removeItem("profilePictureUrl");
        localStorage.removeItem("roleIds");
        form('/sso/login', { callback: window.location.href })
      }
    })
  } else {
    if (to.name !== "HomeIndex" && to.name !== "ResourceDetail") {
      window.scrollTo(0, 0);
    }
    if (to.name === "HomeIndex" || to.name === "ResourceDetail") {
      NProgress.start();
      next();
    } else {
      if (localStorage.getItem("token")) {
        NProgress.start();
        next();
      } else {
        store.dispatch("openVuex", "");
        store.dispatch("checkId", "817485bf52754d8880cb97789f88141d");
        localStorage.removeItem("token");
        localStorage.removeItem("userId");
        localStorage.removeItem("nickName");
        localStorage.removeItem("profilePictureUrl");
        localStorage.removeItem("roleIds");
        form('/sso/login', { callback: window.location.href })
      }
    }
  }


});

router.afterEach(() => {
  NProgress.done();
  // 定时器解决 部分翻译问题
  let num = 0;
  let intervalName = null;
  intervalName = setInterval(() => {
    if (num < 10) {
      translate.execute();
      num++;
    } else {
      clearInterval(intervalName);
    }
  }, 500);
});

export default router;
